module.exports = __webpack_public_path__ + "media/images/front/about/icon05-c4206c3fd27e0b3a9fbdf21961c5bf16.png";